var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellWithRedBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_12086_13195)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 4,
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 4,
    stroke: "url(#paint0_linear_12086_13195)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3604 25.9257H19.6382C19.6382 26.9628 18.8714 27.9998 17.4993 27.9998C16.1272 27.9998 15.3604 26.9628 15.3604 25.9257ZM26.3136 21.5442L25.1308 19.6298C24.6827 18.9049 24.4464 18.0753 24.4464 17.2322V14.5079C24.4464 10.7964 21.33 7.77759 17.5004 7.77759C13.6707 7.77759 10.5543 10.7964 10.5543 14.5079V17.2322C10.5543 18.0753 10.318 18.9049 9.86986 19.6298L8.68705 21.5442C8.32558 22.127 8.31704 22.8301 8.66354 23.4233C9.01004 24.0165 9.63672 24.3702 10.3393 24.3702H24.6635C25.3672 24.3702 25.9939 24.0154 26.3404 23.4233C26.6837 22.8311 26.6751 22.128 26.3136 21.5442Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_12086_13195",
    x: -16.3097,
    y: -16.3097,
    width: 67.6194,
    height: 67.6194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8.15485
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12086_13195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_12086_13195",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWithRedBackground);
export default __webpack_public_path__ + "static/media/bell-with-red-background.dc4f90b53434e772ba993af1215afc00.svg";
export { ForwardRef as ReactComponent };